import actions from '../../actionTypes';

export default actionsList => {
  return {
    type: actions.SET_ACTIONS,
    actions: actionsList
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/setActions.js